export const eccematertua = {
	nombre: "Ecce Mater Tua",
	dia: "Sábado Santo",
	nombrecompleto:
		"Sección de Penitencia de las Congregaciones Marianas Ecce Mater Tua",
	sede: "Iglesia de Santiago Apóstol",
	pasos: 1,
	distancia: [735, 1010],
	penitentes: 150,
	cargadores: 40,
	web: "http://www.diariodecadiz.es/semana_santa/Ecce-Mater_0_1229577738.html",

	ida: [
		{ lng: -6.295614, lat: 36.5297885 },
		{ lng: -6.2955362, lat: 36.5298435 },
		{ lng: -6.2956703, lat: 36.5299502 },
		{ lng: -6.2952733, lat: 36.5303532 },
		{ lng: -6.2950212, lat: 36.5308338 },
		{ lng: -6.2949327, lat: 36.5308403 },
		{ lng: -6.2949648, lat: 36.5314632 },
		{ lng: -6.2964803, lat: 36.53178 },
		{ lng: -6.2964213, lat: 36.5318683 },
		{ lng: -6.2967914, lat: 36.5325645 },
		{ lng: -6.2971106, lat: 36.5330257 },
		{ lng: -6.2984665, lat: 36.5343306 },
		{ lng: -6.2982291, lat: 36.5345537 }
	],
	vuelta: [
		{ lng: -6.2982291, lat: 36.5345537 },
		{ lng: -6.2980306, lat: 36.5347477 },
		{ lng: -6.2962443, lat: 36.5339287 },
		{ lng: -6.2960029, lat: 36.5339664 },
		{ lng: -6.2945008, lat: 36.5322972 },
		{ lng: -6.2940958, lat: 36.5324352 },
		{ lng: -6.2940663, lat: 36.5323942 },
		{ lng: -6.294466, lat: 36.5322595 },
		{ lng: -6.293605, lat: 36.5312821 },
		{ lng: -6.2942514, lat: 36.5309287 },
		{ lng: -6.2943104, lat: 36.5305773 },
		{ lng: -6.29447, lat: 36.5301344 },
		{ lng: -6.2946188, lat: 36.5295083 },
		{ lng: -6.2952988, lat: 36.5296678 },
		{ lng: -6.2955308, lat: 36.5298349 },
		{ lng: -6.2955925, lat: 36.5297896 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-31T01:00",
			latlng: [36.52977, -6.29561]
		},
		{
			name: "Palillero",
			hora: "2018-03-31T02:00",
			latlng: [36.53196, -6.29647]
		},
		{
			name: "San José",
			hora: "2018-03-31T23:00",
			latlng: [36.53455, -6.29822]
		}
	],
	itinerario: [
		[
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza de Candelaria",
			"Montañés",
			"Plaza del Palillero"
		],
		["Novena", "Ancha", "San José (Drcha)"],
		[
			"San Pedro",
			"Beato Diego de Cádiz",
			"Rosario (Drcha)",
			"Plaza San Agustín",
			"Rosario",
			"Plaza Mendizabal",
			"Manzanares",
			"Cobos",
			"Plaza de Pío XII"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/eccematertua.js